import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './mitteilungen.reducer';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import {Mitteilung} from '../../../../clients/veranstaltungen';

/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('MitteilungenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getMitteilungenListe = createSelector(getPageState, (state: PageState): Array<ListInputItem> => {
    const liste = [...state.mitteilungenListe];
    const retListe: Array<ListInputItem> = [];

    liste.forEach(gruppe => {
        gruppe.mitteilungen.map((item: Mitteilung) => {
            retListe.push({
                groupId: gruppe.datum_gruppe.nummer.toString(),
                groupTitle: gruppe.datum_gruppe.name,
                itemId: item.mitteilung_id,
                itemTitle: item.betreff,
                item: {
                    mitteilung: item,
                    gruppe: gruppe.datum_gruppe.name
                }
            });
        });
    });
    return retListe;
});
export const getUiZeigeMitteilungenLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeMitteilungenLaden);
export const getUiZeigeMitteilungenLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeMitteilungenLadefehler);
export const getUiZeigeMitteilungSenden = createSelector(getPageState, (state: PageState) => state.uiZeigeMitteilungSenden);
export const getUiZeigeMitteilungSendefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeMitteilungSendefehler);

export const getVeranstaltungMitteilungBerechtigung = createSelector(getPageState, (state: PageState) => state.veranstaltungMitteilungBerechtigung);
export const getVeranstaltungMitteilungBerechtigungLaden = createSelector(getPageState, (state: PageState) => state.veranstaltungMitteilungBerechtigungLaden);
export const getVeranstaltungMitteilungBerechtigungFehler = createSelector(getPageState, (state: PageState) => state.veranstaltungMitteilungBerechtigungFehler);

export const getMitteilungenGesendetListe = createSelector(getPageState, (state: PageState) => {
    const liste = [...state.mitteilungenGesendetListe];
    const retListe: Array<ListInputItem> = [];

    // console.log('Liste: ', liste);
    liste.forEach(gruppe => {
        gruppe.mitteilungen.map((item: Mitteilung) => {
            retListe.push({
                groupId: gruppe.datum_gruppe.nummer.toString(),
                groupTitle: gruppe.datum_gruppe.name,
                itemId: item.mitteilung_id,
                itemTitle: item.betreff,
                item: {
                    mitteilung: item,
                    gruppe: gruppe.datum_gruppe.name
                }
            });
        });
    });
    // console.log('retliste: ', retListe);
    return retListe;
});
export const getUiZeigeMitteilungenGesendetLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeMitteilungenGesendetLaden);
export const getUiZeigeMitteilungenGesendetLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeMitteilungenGesendetLadefehler);

export const getUiZeigeFunktionsbereicheLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeFunktionsbereicheLaden);
export const getUiZeigeFunktionsbereicheLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeFunktionsbereicheLadefehler);
export const getUiFunktionsbereicheZurAuswahlListe = createSelector(getPageState, (state: PageState) => state.uiFunktionsbereicheZurAuswahlListe);

export const getVeranstaltungBerechtigung = createSelector(getPageState, (state: PageState) => state.veranstaltungBerechtigung);

export const getMitteilungsVorlagen = createSelector(getPageState, (state: PageState) => state.mitteilungsVorlagen);
export const getMitteilungsVorlagenLaden = createSelector(getPageState, (state: PageState) => state.mitteilungsVorlagenLaden);
export const getMitteilungsVorlagenFehler = createSelector(getPageState, (state: PageState) => state.mitteilungsVorlagenFehler);

